import { render, staticRenderFns } from "./BCDetail.vue?vue&type=template&id=1ffdd7eb&scoped=true"
import script from "./BCDetail.vue?vue&type=script&lang=js"
export * from "./BCDetail.vue?vue&type=script&lang=js"
import style0 from "./BCDetail.vue?vue&type=style&index=0&id=1ffdd7eb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffdd7eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffdd7eb')) {
      api.createRecord('1ffdd7eb', component.options)
    } else {
      api.reload('1ffdd7eb', component.options)
    }
    module.hot.accept("./BCDetail.vue?vue&type=template&id=1ffdd7eb&scoped=true", function () {
      api.rerender('1ffdd7eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/BCManage/BCDetail.vue"
export default component.exports